const PropertyCardStatLayoutContainer = ({ children }) => (
  <div className="property-card-body">
    {children}
  </div>
);

export default PropertyCardStatLayoutContainer;
